import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import BreadCrumb from '../../../components/BreadCrumb';
import {
  getCrsClusterListData,
  getCrsCustomerTypeListData,
  getCrsRiskLevelChangeListData,
  getCrsSegmentListData
} from '../../../redux/actions/crs/crsListView';
import { getGlobalSettingsPageInfo } from '../../../redux/actions/settings';
import { CRS_TAB_PAGEID_LIST } from '../../constants/crsContants';
import CustomerListView from './CustomerListView';
import style from './index.scss';
import { fetchAMLSAlertLevel } from '../../../redux/actions/common';

const GLOBAL_SETTING_PAGE_ID = CRS_TAB_PAGEID_LIST[0];

class CRSListingPage extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, alertLevels } = this.props;

    if (dispatch) {
      dispatch(getCrsSegmentListData());
      dispatch(getCrsClusterListData());
      dispatch(getCrsCustomerTypeListData());
      dispatch(getCrsRiskLevelChangeListData());
      dispatch(
        getGlobalSettingsPageInfo({
          pageId: GLOBAL_SETTING_PAGE_ID
        })
      );

      if (!alertLevels?.length) {
        dispatch(fetchAMLSAlertLevel());
      }
    }
  }

  getGSConfig = (q) => {
    if (this.props.settings?.configuration?.data?.uiWidgetGroups) {
      const groups = this.props.settings.configuration.data.uiWidgetGroups;
      return groups
        .find((g) => g.widgetGroupId === q.widgetGroupId)
        ?.widgets.find((w) => w.widgetId === q.widgetId);
    }
    return {};
  };

  render() {
    const {
      customerListData,
      segmentListData,
      clusterListData,
      customerTypeListData,
      riskLevelChangeListData,
      dispatch,
      alertLevels
    } = this.props;

    return (
      <div className={style.root}>
        <div className={style.navPanel}>
          <div className={style.breadcrumb}>
            <BreadCrumb crumbs={[{ label: 'All Customer Risk List' }]} />
          </div>
          <div className={style.pageTitle}>All Customer Risk List</div>
        </div>
        <div className={style.customerList}>
          <CustomerListView
            customerListData={customerListData}
            segmentListData={segmentListData}
            clusterListData={clusterListData}
            customerTypeListData={customerTypeListData}
            riskLevelChangeListData={riskLevelChangeListData}
            GSConfig={this.getGSConfig({
              widgetGroupId: 'CRS_CUSTOMER_LISTING_GROUP',
              widgetId: 'CRS_CUSTOMER_LISTING_WIDGET'
            })}
            dispatch={dispatch}
            alertLevels={alertLevels}
          />
        </div>
      </div>
    );
  }
}

CRSListingPage.propTypes = {
  settings: PropTypes.object,
  customerListData: PropTypes.object,
  segmentListData: PropTypes.object,
  clusterListData: PropTypes.object,
  customerTypeListData: PropTypes.object,
  riskLevelChangeListData: PropTypes.object,
  dispatch: PropTypes.func,
  alertLevels: PropTypes.array
};

function mapStateToProps(state, ownProps = {}) {
  return {
    customerListData: state.crsListView.customerList,
    segmentListData: state.crsListView.segmentList,
    clusterListData: state.crsListView.clusterList,
    customerTypeListData: state.crsListView.customerTypeList,
    riskLevelChangeListData: state.crsListView.riskLevelChangeList,
    settings: state.settings,
    alertLevels: state.amlsCommon.alertLevelConfigs?.data
  };
}

function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CRSListingPage);
